import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type PliTemplatesOptions = {
  id: number
  key: string
  label: string
}

export type PliTemplatesData = PliTemplatesOptions

export async function getRadPliTemplates(id: number): Promise<PliTemplatesData[]> {
  return restApiClient
    .url(constructApiUrl(API.rads.getRadPliTemplates.url, { id }))
    .get<PliTemplatesData[]>()
}
